<div>
  <img [src]="iconPath" [alt]="value">
</div>
